import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable import/no-duplicates */
import React, { Component } from 'react';
import Popup from '../popup';
import Carousel from '../carousel';
import PinchZoom from '../pinch-zoom';
import ActivityIndicator from '../activity-indicator';
import LOAD_STATUS from './utils/loadStatus';
import formatImages from './utils/formatImages';
import showOriginButton from './utils/showOriginButton';

var parseState = function parseState(props) {
  var visible = props.visible,
      images = props.images;
  return {
    visible: visible,
    images: formatImages(images)
  };
};

var ImagePreview = /*#__PURE__*/function (_Component) {
  _inherits(ImagePreview, _Component);

  var _super = _createSuper(ImagePreview);

  function ImagePreview() {
    var _this;

    _classCallCheck(this, ImagePreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.doubleClickTimer = void 0;
    _this.touchStartTime = void 0;
    _this.moving = void 0;
    _this.state = parseState(_this.props);

    _this.onChange = function (index) {
      var onChange = _this.props.onChange;

      _this.setState({
        currentIndex: index
      }, function () {
        if (typeof onChange === 'function') {
          onChange(index);
        }
      });
    };

    _this.close = function () {
      if (_this.moving) {
        return false;
      }

      var onClose = _this.props.onClose;

      if (typeof onClose === 'function') {
        onClose();
      }
    };

    _this.loadOrigin = function () {
      var _this$state = _this.state,
          _this$state$currentIn = _this$state.currentIndex,
          currentIndex = _this$state$currentIn === void 0 ? 0 : _this$state$currentIn,
          images = _this$state.images;
      var _images$currentIndex = images[currentIndex],
          originUrl = _images$currentIndex.originUrl,
          loaded = _images$currentIndex.loaded;

      if (loaded !== LOAD_STATUS.before || !originUrl) {
        return;
      }

      images[currentIndex].loaded = LOAD_STATUS.start;

      _this.setState({
        images: images
      });

      var img = new Image();

      img.onload = function () {
        images[currentIndex].loaded = LOAD_STATUS.end;
        images[currentIndex].url = originUrl;

        _this.setState({
          images: images
        });

        setTimeout(function () {
          images[currentIndex].loaded = LOAD_STATUS.after;

          _this.setState({
            images: images
          });
        }, 1500);
      };

      img.src = originUrl;
    };

    _this.onWrapperTouchStart = function () {
      _this.touchStartTime = Date.now();
    };

    _this.onWrapperTouchEnd = function () {
      var deltaTime = Date.now() - _this.touchStartTime;

      var onClose = _this.props.onClose; // prevent long tap to close component

      if (deltaTime < 300) {
        if (!_this.doubleClickTimer && !_this.moving) {
          _this.doubleClickTimer = setTimeout(function () {
            _this.doubleClickTimer = null;

            if (typeof onClose === 'function') {
              onClose();
            }
          }, 300);
        } else {
          _this.doubleClickTimer && clearTimeout(_this.doubleClickTimer);
          _this.doubleClickTimer = null;
        }
      }

      _this.moving = false;
    };

    _this.onWrapperTouchMove = function () {
      if (_this.touchStartTime) {
        _this.moving = true;
      }
    };

    _this.onWrapperMouseDown = function () {
      _this.touchStartTime = Date.now();
    };

    _this.onWrapperMouseUp = function () {
      setTimeout(function () {
        _this.moving = false;
      }, 0);
      _this.touchStartTime = 0;
    };

    _this.renderImages = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          minScale = _this$props.minScale,
          maxScale = _this$props.maxScale;
      var images = _this.state.images;
      return images.map(function (item, i) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "__item"),
          key: +i
        }, /*#__PURE__*/React.createElement(PinchZoom, {
          className: "".concat(prefixCls, "__item__img"),
          minScale: minScale,
          maxScale: maxScale
        }, /*#__PURE__*/React.createElement("img", {
          src: item.url,
          alt: "",
          draggable: false
        })));
      });
    };

    return _this;
  }

  _createClass(ImagePreview, [{
    key: "renderPagination",
    value: function renderPagination() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          showPagination = _this$props2.showPagination;
      var _this$state2 = this.state,
          _this$state2$currentI = _this$state2.currentIndex,
          currentIndex = _this$state2$currentI === void 0 ? 0 : _this$state2$currentI,
          visible = _this$state2.visible,
          images = _this$state2.images;

      if (visible && showPagination && images && images.length > 1) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "__index")
        }, currentIndex + 1, " / ", images.length);
      }

      return null;
    }
  }, {
    key: "renderOriginButton",
    value: function renderOriginButton() {
      var _this$state3 = this.state,
          images = _this$state3.images,
          _this$state3$currentI = _this$state3.currentIndex,
          currentIndex = _this$state3$currentI === void 0 ? 0 : _this$state3$currentI;
      if (images.length === 0) return;
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          locale = _this$props3.locale,
          activeIndex = _this$props3.activeIndex;
      var loaded = images[currentIndex].loaded;

      if (loaded && showOriginButton(images, activeIndex) && loaded !== LOAD_STATUS.after) {
        return /*#__PURE__*/React.createElement("button", {
          className: "".concat(prefixCls, "__origin__button"),
          onClick: this.loadOrigin
        }, loaded === LOAD_STATUS.start && /*#__PURE__*/React.createElement(ActivityIndicator, {
          className: "".concat(prefixCls, "__loading"),
          type: "spinner"
        }), locale && locale[loaded]);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var prefixCls = this.props.prefixCls;
      var _this$state4 = this.state,
          _this$state4$currentI = _this$state4.currentIndex,
          currentIndex = _this$state4$currentI === void 0 ? 0 : _this$state4$currentI,
          visible = _this$state4.visible,
          images = _this$state4.images;
      return /*#__PURE__*/React.createElement(Popup, {
        direction: "center",
        visible: visible,
        className: prefixCls
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__content"),
        onTouchStart: this.onWrapperTouchStart,
        onTouchEnd: this.onWrapperTouchEnd,
        onTouchCancel: this.onWrapperTouchEnd,
        onTouchMove: this.onWrapperTouchMove,
        onMouseDown: this.onWrapperMouseDown,
        onMouseMove: this.onWrapperTouchMove,
        onMouseUp: this.onWrapperMouseUp,
        onClick: this.close
      }, visible && (images !== null && images !== void 0 && images.length ? /*#__PURE__*/React.createElement(Carousel, {
        showPagination: false,
        onChange: this.onChange,
        activeIndex: currentIndex
      }, this.renderImages()) : /*#__PURE__*/React.createElement(ActivityIndicator, {
        className: "".concat(prefixCls, "__loading"),
        type: "spinner",
        size: "lg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__footer")
      }, this.renderOriginButton(), this.renderPagination()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ('visible' in nextProps && nextProps.visible !== state.prevVisible || 'activeIndex' in nextProps && nextProps.activeIndex !== state.prevActiveIndex || 'images' in nextProps && nextProps.images !== state.prevImages) {
        return {
          visible: nextProps.visible,
          activeIndex: nextProps.activeIndex,
          currentIndex: nextProps.activeIndex,
          images: formatImages(nextProps.images),
          prevVisible: nextProps.visible,
          prevActiveIndex: nextProps.activeIndex,
          prevImages: nextProps.images
        };
      }

      return null;
    }
  }]);

  return ImagePreview;
}(Component);

ImagePreview.defaultProps = {
  prefixCls: 'za-image-preview',
  activeIndex: 0,
  showPagination: true,
  visible: false
};
export { ImagePreview as default };